<template>
    <section>
		<div class="logo"></div>
		<div v-if='type == "member"' class="pay-c">
			<p class="text">支付成功</p>
			<p class="menber-discount">购买会员成功，下单即可享受折扣</span></p>
			<div>
				<div class="go-order now" @click="goOnOrder">立即下单</div>
				<div class="look-order back-m" @click="back">返回</div>
			</div>
		</div>

		<div v-else-if='type == "add"' class="pay-c">
			<p class="text">支付成功</p>
            <p class="text">若订单未成功，追加费用将一并退还</p>
            <div class="btn-wrap">
            	<div class="go-order" @click="backList">返回列表</div>
            	<div class="look-order" @click="lookForOrder">查看详情</div>
            </div>
		</div>

		<div v-else class="pay-c">
			<p class="money">￥{{payPrice}}</p>
			<p class="menber-discount" v-if='isMember==2'>会员已优惠<span>￥{{memberDiscount}}</span></p>
			<div class="tips-wrap">
				<img src="@/assets/images/order-manage/ic_question.png" @click="isPayTips=true"/>
				<p class="tips">保障计划：处理周期为五天</p>
				<p>未成功订单随时退</p>
			</div>

			<div class="btn-wrap">
				<div class="go-order" @click="backList">返回列表</div>
				<div class="look-order" @click="lookForOrder">查看订单</div>
			</div>
		</div>

		<div class="modal-wrap"  v-if="isPayTips">
		    <div class="modal-plan">
				<img src="@/assets/images/order-manage/ic_order_off.png" class="close-icon pay-img" @click="isPayTips=false">
				<div class="modal">
					<div class="order-detail order-content">
						<div class="title">保障计划</div>
						<div class="agree-text">
						   <p>1、订单处理周期为五天，超过处理时间，商家可以直接申请全额退还款项，系统审核后款项原路退回。</p>
						   <p>2、订单处理期间，订单状态为“处理中”，表示订单正在处理，商家无故中途撤单，按<span style="color: #4184F4;" @click="isAgreeMent=true">《用心淘下单协议》</span>只能退还50%支付款项，系统审核后款项原路退回。</p>
						   <p>3、订单处理期间，订单状态变更为“未解决”，表示订单未处理成功， 商家可以直接申请全额退款，系统审核后款项原路退回。</p>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 下单协议弹框 -->
		<show-agree-ment v-if="isAgreeMent" @close-modal="isAgreeMent=false"></show-agree-ment>
    </section>
</template>

<script>
	import ShowAgreeMent from '@/components/ShowAgreeMent'
    import utils from '@/assets/jslibs/utils'
	import {getUserInfo} from '@/api/common'
    export default {
        name: 'index',
		data(){
			return{
				totalPrice:this.$route.query.totalPrice,		//原支付金额
				order_uuid:this.$route.query.order_uuid,
				type:this.$route.query.type,
				memberDiscount:"",		//会员优惠金额
				payPrice:"",           //实际支付的金额
				isMember:null,
				isAgreeMent:false,
				isPayTips:false
			}
		},

		beforeCreate(){
			sessionStorage.setItem("roleType","customer");
            //清除用户下单时的信息回填，用户填写信息只在用户下单时存在
            sessionStorage.removeItem("params");
            sessionStorage.removeItem("newOrder");
            sessionStorage.removeItem("placeOrderId");
		},

        created(){
            this.getUserInfo();		//查看用户会员情况
        },

        mounted(){
           document.title = "支付成功"
        },

        methods: {
			async getUserInfo(){
				const { data, status } = await getUserInfo();
				if(status=="200"){
					if(data.is_member){
						this.isMember = data.is_member;
						if(this.isMember=="2" && this.type!="add"){//会员,并且非追加订单
							this.memberDiscount = (Number(this.totalPrice)/Number((data.member_discount)) - Number(this.totalPrice)).toFixed(2);
							this.payPrice = this.totalPrice;
						}else{
							this.payPrice = this.totalPrice;
						}
					}else{
						this.payPrice = this.totalPrice;
					}
				}
			},

			// 立即下单
			goOnOrder(){
				sessionStorage.setItem("peg",1);
				sessionStorage.setItem("stamp","placeOrder");
				this.$router.push({path:'./index'})
			},

			//返回列表
			backList(){
				sessionStorage.setItem("peg",2);
				sessionStorage.setItem("stamp","order");
				this.$router.push({path:'./index'})
			},

			//查看订单
			lookForOrder(){
				this.$router.push({path:'./order-detail',query:{order_uuid:this.order_uuid}})
			}
        },

		components:{
			ShowAgreeMent
		}
    }
</script>

<style lang='less' scoped>
	/* @import '~@/assets/styles/variable.less'; */
	/* @import '~@/assets/styles/handleMethods.less'; */
	/* @import '~@/assets/styles/reset.css'; */

    section,body{font-family:PingFangSC-Regular,PingFang SC;font-weight:400;background: #fff}
    .logo{width: 90px;height: 90px;margin: 0 auto;margin-top: 33px;background: url(../../assets/images/home/pic_right2_pitchon.png) no-repeat center center;background-size: cover}

	.text{color:rgba(20,20,20,1);font-size: 18px;margin-top: 16.5px;text-align:center}
	.money{text-align:center;font-size:23px;font-family:PingFangSC-Medium,PingFang SC;font-weight:500;color:rgba(20,20,20,1);}
	.menber-discount{color: #C1C1C1;font-size: 14px;text-align: center;margin-top: 6px;}
	.menber-discount span{color:#FF8630;font-size: 14px;padding-left: 10px;}
	.home-order{overflow: hidden;width: 220px;margin: 0 auto;margin-top: 22px;}
	.order{color: rgba(102,102,102,1);font-size: 15px;float: left;}
	.home{color: rgba(102,102,102,1);font-size: 15px;float: right;}
	.tips-wrap{margin-top: 48px;font-size:14px;color:rgba(193,193,193,1);text-align: center;}
	.tips-wrap img{width: 14px;}
	.tips-wrap .tips{padding-left:8px;display: inline-block;}

	.btn-wrap{display: flex;margin: 0 48px;align-items: center;justify-content: space-between;margin-top: 27px;}
	.go-order{width:130px;height:34px;line-height: 34px;background:rgba(65,132,244,0.1);border-radius:4px;border:1px solid rgba(65,132,244,0.5);text-align: center;color:rgba(65,132,244,1);font-size: 14px;}
	.look-order{width:130px;height:34px;line-height: 34px;background:rgba(102,102,102,0.06);border-radius:4px;border:1px solid rgba(193,193,193,1);text-align: center;color:rgba(51,51,51,1);font-size: 14px;}
	.back{margin: 0 auto;margin-top: 27px}

	.now{margin: 0 auto;margin-top: 40px}
	.back-m{margin: 0 auto;margin-top: 10px}
	.pay-c{margin-top: 20px;}






	/* 新支付弹框 */
	.modal{width: 320px;background: #fff;margin: 0 auto;padding-bottom: 25px;}
	.title{padding: 12px 21px;font-size:18px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(51,51,51,1);text-align: center;border-bottom: 1px solid #E9E9E9}
	.pay-wrap{width:320px;padding: 27px 0 18px 0;background:rgba(65,132,244,0.08);text-align:center;}
	.pay-tips{font-size:14px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(74,74,74,1);}
	.pay-cash{padding: 7px 0 5px 0;font-size:25px;font-family:PingFangSC-Semibold,PingFang SC;font-weight:600;color:rgba(20,20,20,1);}
	.pay-cash span{font-size:34px;font-family:PingFangSC-Semibold,PingFang SC;font-weight:600;color:rgba(20,20,20,1);}
	.pay-plan{display: inline-block;vertical-align: middle;font-size:13px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(174,174,174,1);}
	.question{width: 14px;height: 14px;display: inline-block;vertical-align: middle;}
	.info-wrap{background: #fff;padding-left: 28px;padding-right: 15px;display: -webkit-box;display: -ms-flexbox;display: flex;flex-wrap: wrap;justify-content: space-between;align-items: center}
	.type-wrap{padding: 0 10px}
	.have-border{border-bottom: 1px solid #E9E9E9;padding-left: 20px}
	//支付提示弹框
	.pt-img{height: 20px;margin-right: 8px;display: inline-block;vertical-align:middle}
	.link-wrap{font-size: 0;height: 1.38666667rem;margin: 0 15px;line-height: 1.38666667rem;border-bottom: 0.026667rem solid #EEEEEE;}
	.link{display: inline-block;vertical-align: middle;color:rgba(20,20,20,1);font-size: 15px;font-family: PingFangSC-Semibold,PingFang SC;font-weight: 600;color: rgba(51,51,51,1);}
	.agree-text{padding: 20px 14px 10px 14px}
	.agree-text p{font-size:14px;margin-bottom: 15px;line-height: 22px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(102,102,102,1);letter-spacing:1px;}

	.modal-plan .modal{height: 386px}
</style>
